export enum APIKey {
  USER = 'user',
  SHIFT_NOTE = 'shift-note',
  SHIFT_NOTE_REVISIONS = 'shift-note-revisions',
  SITE_SHIFTS = 'site-shifts',
  INSTANT_REFLEXES = 'instant-reflexes',
  FORM_TEMPLATES = 'form-templates',
  PROFILES = 'profiles',
  DEPARTMENTS = 'departments',
  SIGNALS = 'signals',
  ECOACH_SESSIONS = 'ecoach-sessions',
  DEMO_INDUSTRIES = 'demo-industries',
  DEMO_COMPANY_SIZE_CHOICES = 'demo-company-size-choices',
  TEAM_LEAD_INSIGHTS = 'team-lead-insights',
  DOCUMENT = 'document',
  DOCUMENT_DOWNLOAD = 'document-download',
  TEAM_SITES = 'team-sites',
  OVERVIEW_NUMBERS = 'overview-numbers',
  OVERVIEW_URGENCY = 'overview-urgency',
  OVERVIEW_RISKS = 'overview-risks',
  URGENCY_STATISTICS = 'urgency-statistics',
  RISK_STATISTICS = 'risk-statistics',
  SIGNAL_STATISTICS = 'signal-statistics',
  NOTE_HEATMAP = 'note-heatmap',
  INSIGHTS_SUMMARY = 'insights-summary',
  INSIGHTS_EVENTS = 'insights-events',
  INSIGHTS_EVENT = 'insights-event',
  EVENT = 'event',
  HANDOVER = 'handover',
  HANDOVER_PREFERENCES = 'handover-preferences',
  GUIDANCE_QUESTIONS = 'guidance-questions',
}

export const apiRoutes = {
  siteShifts: () => '/e-coach/site-shifts/',
  siteShift: (id) => `/e-coach/site-shifts/${id}/`,
  shiftNotes: () => '/e-coach/shift-notes/',
  shiftNote: (id) => `/e-coach/shift-notes/${id}/`,
  shiftNoteRevisions: (id) => `/e-coach/shift-notes/${id}/revisions/`,
  unlinkShiftNoteFromEvent: (id) => `/e-coach/shift-notes/${id}/unlink-event/`,
  markShiftNoteFalseAlarm: (id) => `/e-coach/shift-notes/${id}/false-alarm/`,
  generateInstantReflex: (id) => `/e-coach/shift-notes/${id}/instant-reflex/`,
  extractEntities: (id) => `/e-coach/shift-notes/${id}/extract-entities/`,
  instantReflex: (id) => `/e-coach/instant-reflexes/${id}/`,
  instantReflexFeedback: (id) => `/e-coach/instant-reflexes/${id}/feedback/`,
  reflexStepAnswer: (id) => `/e-coach/reflex-steps/${id}/answer/`,
  shiftNoteAttachments: (noteId) =>
    `/e-coach/shift-notes/${noteId}/attachments/`,
  shiftNoteAttachment: (id) => `/e-coach/shift-notes-attachments/${id}/`,
  formTemplates: () => '/e-coach/form-templates/',
  formInstance: (id) => `/e-coach/form-instances/${id}/`,
  profiles: () => '/e-coach/profiles/',
  profile: (id) => `/e-coach/profiles/${id}/`,
  departments: () => '/e-coach/departments/',
  signals: () => '/e-coach/signals/',
  notificationSettings: () => '/members/notification-settings/',
  pushSubscriptions: () => '/e-coach/push-subscriptions/',
  pushSubscriptionsUnregister: () => '/e-coach/push-subscriptions/unregister/',
  pushVapidPublicKey: () => '/e-coach/push-subscriptions/vapid-public-key/',
  ecoachSessions: () => '/e-coach/sessions/',
  ecoachSession: (id: string) => `/e-coach/sessions/${id}/`,
  ecoachSessionStatus: (id: string) =>
    `/e-coach/sessions/${id}/resolution-status/`,
  ecoachSessionHide: (id: string) => `/e-coach/sessions/${id}/hide`,
  demoIndustries: () => '/demo/industries',
  demoCompanySizeChoices: () => '/demo/company-size-choices',
  demoRegister: () => '/demo/register',
  demoReset: () => '/e-coach/sessions/demo/reset/',
  userMe: () => '/users/me/',
  userIdentity: () => '/users/identity/',
  userLanguage: () => '/users/language/',
  tourCompleted: () => '/members/tour-completed/',
  communicationPreferences: () => '/members/communication-preferences/',
  handoverPreferences: () => '/members/handover-preferences/',
  teamLeadInsights: () => '/teams/insights/',
  document: (id?: string) => `/documents/${id}/`,
  documentDownload: (id?: string) => `/documents/${id}/download/`,
  teamSites: () => '/teams/sites/',
  overviewNumbers: () => '/e-coach/insights/overview-numbers/',
  overviewUrgency: () => '/e-coach/insights/overview-urgency/',
  overviewRisks: () => '/e-coach/insights/overview-risks/',
  urgencyStatistics: () => '/e-coach/insights/urgency-statistics/',
  riskStatistics: () => '/e-coach/insights/risk-statistics/',
  signalStatistics: () => '/e-coach/insights/signal-statistics/',
  noteHeatmap: () => '/e-coach/insights/note-heatmap/',
  insightsSummary: () => '/e-coach/insights/summary/',
  insightsEvents: () => '/e-coach/insights/events/',
  insightsEvent: (id: string) => `/e-coach/insights/events/${id}/`,
  events: () => '/e-coach/events/',
  event: (id: string) => `/e-coach/events/${id}/`,
  guidanceQuestions: () => '/e-coach/guidance-questions/',
  guidanceQuestionAnswer: (id: string) =>
    `/e-coach/guidance-questions/${id}/answer/`,
  handover: () => '/e-coach/handovers/',
  login: () => '/login/',
  loginToken: () => '/login/token/',
  logout: () => '/logout/',
  logoutAll: () => '/logout/all/',
};
